import React from 'react';
import InputMask from 'react-input-mask';
import * as s from './styled-input-usuario';

const handleKeyDown = (event) => {
  if (event.key === 'Enter') {
    event.preventDefault()
  }
}
const Input = ({
  alert,
  error,
  id,
  name,
  onChange,
  onBlur,
  value,
  mask,
  placeholder,
  style,
  width,
  height,
  margin,
  type,
  focused,
  onClick,
  login,
  disabled,
  maxLength,
  titleForm,
}) => {
  return (
      <s.Container
        disabled={disabled}
        focused={focused}
        width={width}
        margin={margin}
        height={height}
        style={style}
        title={placeholder}
        login={login}
        alert={alert}
        error={error}
      >
        <s.TitleForm><strong>{titleForm}</strong></s.TitleForm>
        <InputMask className="inputMasks"
          onKeyDown={handleKeyDown}
          id={id}
          name={name}
          mask={mask}
          maxLength={maxLength}
          width={width}
          height={height}
          onClick={onClick}
          placeholder={placeholder}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          type={type || 'text'}
          login={login}
        />
      </s.Container>
  );
};

export default Input;
